import { Injectable, signal } from '@angular/core';

/**
 * This service allows the application to set something in the status bar (footer)
 * For now, only Devs will see anything in the status bar and maybe it'll stay that way.
 */
@Injectable({
  providedIn: 'root'
})
export class StatusBarService {

  stsTokenSignal = signal<boolean>(false);

  entraTokenSignal = signal<boolean>(false);

  /**
   * Show the Entra icon for a sec
   */
  triggerEntraTokenIcon() {
    requestAnimationFrame(() => {
      this.entraTokenSignal.set(true);

      setTimeout(() => {
        this.entraTokenSignal.set(false);
      }, 1000);
    });
  }

  // Show the STS icon for a sec
  triggerStsTokenIcon() {

    queueMicrotask(() =>  {
      this.stsTokenSignal.set(true);

      setTimeout(() => {
        this.stsTokenSignal.set(false);
      }, 1000);
    });
  }

}
